import { Controller } from "@hotwired/stimulus";

// Checks whether elm is a parent of t
function checkParent(t, elm) {
  while (t.parentNode) {
    if (t == elm) return true;
    t = t.parentNode;
  }
  return false;
}

export default class extends Controller {
  static targets = ["content", "toggle"];

  toggle(e) {
    var target = (e && e.target) || (e && e.srcElement);

    // Nav Menu
    if (!checkParent(target, this.contentTarget)) {
      // click NOT on the menu
      if (checkParent(target, this.toggleTarget)) {
        // click on the toggle button
        const isOpen = !this.contentTarget.classList.contains("max-h-0");
        if (isOpen) {
          this.closeMenu();
        } else {
          this.openMenu();
        }
      } else {
        // click outside, close menu
        this.closeMenu();
      }
    }
  }

  openMenu() {
    this.contentTarget.classList.remove("max-h-0", "opacity-0", "pointer-events-none");
    this.contentTarget.classList.add("max-h-[300px]", "opacity-100", "pointer-events-auto");
  }

  closeMenu() {
    this.contentTarget.classList.remove("max-h-[300px]", "opacity-100", "pointer-events-auto");
    this.contentTarget.classList.add("max-h-0", "opacity-0", "pointer-events-none");
  }
}
